export default "__VITE_ASSET__DoH6NEpi__"